const TD = 'TD'

const tableOnRowClick = (event, row, callback) =>
  event.target.tagName === TD ? callback(row) : undefined

export default tableOnRowClick
